module.exports = __webpack_public_path__ + "img/C33829_48171A_752523_942923-256px.84aa7591.png";